<template>
<div class="home">

   <div class="profile text-center">
      <img class="login-logo" alt="logo" src="@/assets/logo-login.jpg"/>
   </div>
   <slot></slot>
   <div>
      <sign-in-form v-if="no_blocking_errors"></sign-in-form>
   </div>
   
</div>
</template>

<script>
// @ is an alias to /src
'use strict'
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import SignInForm from '@/components/sign-in-form';


export default {
   name: 'home',

   components: {
      SignInForm
   },

   data (){
      return {
      };
   },

   computed:{

      ...mapGetters([
         'no_blocking_errors',
         'max_attempts',
         'message_too_many_logins',
         'attempts'
      ])
   }, // /computed()

   methods: {

      ...mapActions([
         'set_page_title'
      ])

   },// methods{}

   mounted (){
      this.set_page_title( '' );

      // if( this.attempts >= this.max_attempts ){
      //    this.show_error({
      //       code: 409,
      //       message: this.message_too_many_logins
      //    })
      // }
      

      // this.show_wait( `Fetching a resource...` );

      // this.fetch_a_resource()
      // .then((o_result) => {
      //    this.clear_show();
      //    this.results = o_result;
      // })
      // .catch((o_error) => {
      //    this.show_error( o_error.message );
      // });
   },// /mounted()
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home
{
   max-width: 30em;
   margin: auto;
   background-color: #ffffff;
   padding: 1em;
}

.login-logo
{
   width: 100%;
}
/**
 * Hide the number scroll arrows in number input fields.
 */
/*input[type=number]
{
   -moz-appearance: textfield;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button
{
   -webkit-appearance: none;
   margin: 0;
}*/


/* Small only */
/*@media screen and (min-width: 576px) {}*/

/* Medium and up */
/*@media screen and (min-width: 768px) {}*/

/* Medium only */
/*@media screen and (min-width: 768px) and (max-width: 991px) {}*/

/* Large and up */
/*@media screen and (min-width: 992px) {}*/

/* Large only */
/*@media screen and (min-width: 992px) and (max-width: 1199px) {}*/

/* X-Large and up */
/*@media screen and (min-width: 1200px) {}*/

</style>
